/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const publishingTargetState = {
    selected: undefined,
    targets: [],
    webpagesLoaded: false,
    webpages: [],
    imagesLoaded: false,
    images: [],
    documentsLoaded: false,
    documents: [],
};
